import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Demo from './Demo';

ReactDOM.render(
  <React.StrictMode>
    <Demo />
  </React.StrictMode>,
  document.getElementById('root')
);
